import { useDispatch, useSelector } from 'react-redux'
import { IoTrash } from 'react-icons/io5'
import colors from 'tailwindcss/colors'

import { useModal } from '@/hooks/useModal'
import { useToast } from '@/hooks/useToast'
import { api } from '@/services/api'
import { ReduxProps } from '@/storage'
import {
  SocialMediaProps,
  handleSetSocialMedia,
} from '@/storage/modules/socialMedia/reducer'
import { SocialMediaResponseProps } from '@/types/socialMediaProps'

import { EmptyState } from '../EmptyState'
import { FormSocialMedia } from '../FormSocialMedia'

export function SocialMedia() {
  const { openModal } = useModal()
  const { showToast } = useToast()
  const dispatch = useDispatch()

  const { socialMedia } = useSelector<ReduxProps, SocialMediaProps>(
    (state) => state.socialMedia,
  )

  const handleRemoveSocialMedia = async (socialMediaId: string) => {
    try {
      await api.delete(`/social-media/${socialMediaId}`)

      const response = await api
        .get('/social-media')
        .then((res) => res.data.data as SocialMediaResponseProps[])

      dispatch(handleSetSocialMedia({ socialMedia: response }))

      showToast('Social media removed successfully', {
        type: 'success',
        theme: 'light',
      })
    } catch (error) {
      showToast('Error removing social media', {
        type: 'error',
        theme: 'light',
      })
    }
  }

  return (
    <div>
      {socialMedia.length === 0 && (
        <EmptyState
          title="No social media yet"
          description="Create the first social media item to link artist profiles."
        />
      )}
      {socialMedia.map((item) => (
        <div key={item.id} className="relative mt-8">
          <button
            title="Remove"
            className="absolute -right-1.5 -top-1.5 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-red-600 bg-red-600 shadow-sm transition hover:bg-red-700"
            onClick={() => {
              openModal({
                textConfirm: 'Delete',
                description: 'Do you really want to delete the social media?',
                title: 'Attention',
                confirm() {
                  handleRemoveSocialMedia(item.id)
                },
              })
            }}
          >
            <IoTrash size={14} color={colors.white} />
          </button>

          <button
            className="bg-white rounded-2xl p-7 top-5 flex gap-4 justify-between items-center border hover:border-gray-300 w-full text-left"
            onClick={() => {
              openModal({
                small: true,
                children: <FormSocialMedia isExist={item} />,
              })
            }}
          >
            <p className="font-semibold text-gray-500">{item.title}</p>
          </button>
        </div>
      ))}
    </div>
  )
}
